/* eslint-disable react/jsx-props-no-spreading -- wrappers here forward props wholesale */
import { BrowserRouter, StaticRouter } from 'react-router-dom';

import { useRailsContext } from './RailsContext';
import { canUseDOM } from './helpers/dom';
import { pageUrl } from './helpers/page_url';
import { connectLocation } from './location/LocationConnectors';
import wrappedInReduxProvider from './wrappedInReduxProvider';

const SwitchingRouter = ({ ssrLocation, ...props }) =>
  canUseDOM() ? <BrowserRouter {...props} /> : <StaticRouter location={ssrLocation} {...props} />;

const RailsContextRouter = wrappedInReduxProvider(SwitchingRouter);

const ReduxLocationRouter = wrappedInReduxProvider(
  connectLocation(props => <SwitchingRouter ssrLocation={pageUrl(props)} {...props} />)
);

const RouterWithSSR = props => {
  const railsContext = useRailsContext();

  if (!railsContext) {
    return <ReduxLocationRouter {...props} />;
  }

  const { pathname = '', search = '' } = railsContext;

  return <RailsContextRouter ssrLocation={{ pathname, search }} {...props} />;
};

export default RouterWithSSR;
